export default __webpack_public_path__ + "static/media/7minfitness@2x.ea7de56c.jpg";